import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSocialMediaRequest,
  addSocialMediaRequest,
  resetData,
} from "../../../redux/jobseeker/social_media/actions";
import { customOptionsStyle, socialMediaOptions } from "../../../Constant";
import { showSweetAlert } from "../../Common/SweetAlert";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { showToast } from "../../Common/Toast";
import { FiPlusSquare } from "react-icons/fi";
import Select from "react-select";
import {
  Button,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import AddSocialMedia from "./AddSocialMedia";
import validator from "validator"; // Import the validator library

// Social Media Entry Component
const SocialMediaEntry = ({
  item,
  editableData,
  editableErrors,
  handleInputChange,
  handleSaveClick,
  handleSocialMediaDeleteClick,
}) => {
  const currentData = editableData[item.id] || {
    social_profile_name: item.social_profile_name,
    url: item.url,
  };

  return (
    <>
      <Row>
        <Col md="6">
          <FormGroup className="me-2">
            <Label for={`socialProfileName-${item.id}`}>
              Social Profile Name <span className="text-danger">*</span>
            </Label>
            <Select
              placeholder="Select profile name"
              name="social_profile_name"
              styles={customOptionsStyle}
              options={socialMediaOptions}
              onChange={(selectedOption) =>
                handleInputChange(
                  item.id,
                  "social_profile_name",
                  selectedOption?.value
                )
              }
              value={socialMediaOptions.find(
                (option) => option.value === currentData.social_profile_name
              )}
              isDisabled
            />
            {editableErrors[item.id]?.social_profile_name && (
              <div className="text-danger mt-1">
                {editableErrors[item.id].social_profile_name}
              </div>
            )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup className="me-2">
            <Label for={`url-${item.id}`}>
              URL <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id={`url-${item.id}`}
              value={currentData.url}
              onChange={(e) =>
                handleInputChange(item.id, "url", e.target.value)
              }
            />
            {editableErrors[item.id]?.url && (
              <div className="text-danger mt-1">
                {editableErrors[item.id].url}
              </div>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="d-flex justify-content-end">
            <Button
              className="me-2"
              color="primary"
              size="sm"
              onClick={() => handleSaveClick(item)}
            >
              Save
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() => handleSocialMediaDeleteClick(item.id)}
            >
              Delete
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};

// Main Component
const Editsocialmedia = ({ profileData, validationMessages }) => {
  const dispatch = useDispatch();
  const [newEntry, setNewEntry] = useState(null);
  const [editableData, setEditableData] = useState(() =>
    profileData?.online_detail_result?.reduce((acc, item) => {
      acc[item.id] = {
        social_profile_name: item.social_profile_name,
        url: item.url,
        id: item.id,
      };
      return acc;
    }, {})
  );

  const [editableErrors, setEditableErrors] = useState({});

  const existingSocialProfiles = Object.values(editableData || {}).map(
    (item) => item.social_profile_name
  );

  const availableSocialMediaOptions = socialMediaOptions.filter(
    (option) => !existingSocialProfiles.includes(option.value)
  );

  const handleInputChange = (id, field, value) => {
    setEditableData((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
    setEditableErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: null, // Clear specific error
      },
    }));
  };

  const validateForm = (formData) => {
    let errors = {};
    let isValid = true;

    if (!formData.social_profile_name) {
      errors.social_profile_name = "Social profile name is required";
      isValid = false;
    }

    const urlRegex = /^[a-zA-Z0-9:/?&=._-]+$/; // Allowed URL characters

    if (!formData.url) {
      errors.url = "URL is required";
      isValid = false;
    } else {
      try {
        // Ensure URL starts with http:// or https://
        if (!validator.isURL(formData.url, { require_protocol: true })) {
          throw new Error("Invalid URL format");
        }

        // Prevent multiple "https://"
        const httpsCount = (formData.url.match(/https:\/\//g) || []).length;
        if (httpsCount > 1) {
          throw new Error("Malformed URL");
        }

        // Check for special characters
        if (!urlRegex.test(formData.url)) {
          throw new Error("URL contains invalid characters");
        }

        const urlObject = new URL(formData.url);
        const hostname = urlObject.hostname.replace(/^www\./, ""); // Normalize domain

        const domainMap = {
          FACEBOOK: "facebook.com",
          GITHUB: "github.com",
          LINKEDIN: "linkedin.com",
          TWITTER: ["twitter.com", "x.com"],
          STACK_OVERFLOW: "stackoverflow.com",
        };

        const profileKey = formData.social_profile_name.toUpperCase();
        const profileName = capitalizeFirstLetter(formData.social_profile_name);

        if (domainMap[profileKey]) {
          const expectedDomains = domainMap[profileKey];
          const isValidDomain = Array.isArray(expectedDomains)
            ? expectedDomains.includes(hostname)
            : hostname === expectedDomains;

          if (!isValidDomain) {
            errors.url = `Invalid ${profileName} URL`;
            isValid = false;
          }
        }
      } catch (error) {
        errors.url = error.message;
        isValid = false;
      }
    }
    console.log("formData22",formData,errors);
    // Update the errors state
    setEditableErrors((prev) => ({
      ...prev,
      [formData.id]: errors, // Ensure formData.id is defined
    }));

    return isValid;
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const submitForm = (item) => {
    
    const formData = editableData[item.id] || {};

    console.log("item33",formData);
    const isValid = validateForm(formData);

    if (!isValid) {
      return;
    }

    const data = {
      id: item.id === "new" ? null : item.id,
      social_profile_name: formData.social_profile_name,
      url: formData.url,
    };

    dispatch(addSocialMediaRequest(data));

    setEditableErrors((prev) => {
      const updated = { ...prev };
      delete updated[item.id];
      return updated;
    });
  };

  const handleSaveClick = (item) => {
    submitForm(item);
  };

  const handleSocialMediaDeleteClick = (id) => {
    showSweetAlert("confirm", {
      message: "Are you sure you want to delete this social media link?",
      fun: () => handleSocialMedia(id),
    });
  };

  const handleSocialMedia = (id) => {
    dispatch(deleteSocialMediaRequest({ id: id }));
  };

  const socialReducerData = useSelector((state) => state.socialMediaReducer);

  useEffect(() => {
    if (socialReducerData.status && socialReducerData.message !== "") {
      showToast("success", socialReducerData.message);

      dispatch(resetData());
      dispatch(fetchJobseekerDataRequest());
    } else if (
      socialReducerData.status === false &&
      socialReducerData.message !== ""
    ) {
      showToast("error", socialReducerData.message);

      dispatch(resetData());
      dispatch(fetchJobseekerDataRequest());
    }
  }, [socialReducerData, dispatch]);

  const handleAddClick = () => {
    setNewEntry({});
  };

  const [showValidationMessages, setValidationMessages] = useState();
  useEffect(() => {
    if (validationMessages && typeof validationMessages === "object") {
      setValidationMessages(validationMessages);
      console.log("validationMessages888", validationMessages);
    }
  }, [validationMessages]);

  return (
    <>
      <CardHeader className="d-flex justify-content-between align-items-end">
        <h5>Social Media Links</h5>
        {!newEntry && availableSocialMediaOptions.length > 0 && (
          <FiPlusSquare
            className="add-icon"
            size={22}
            title="Add"
            onClick={handleAddClick}
          />
        )}
      </CardHeader>
      <CardBody>
        {showValidationMessages && (
          <div className="text-danger mb-4">{showValidationMessages.urls}</div>
        )}
        {newEntry && (
          <AddSocialMedia
            onClose={() => setNewEntry(false)}
            options={availableSocialMediaOptions}
          />
        )}
        {profileData?.online_detail_result?.map((item) => (
          <SocialMediaEntry
            key={item.id}
            item={item}
            editableData={editableData}
            editableErrors={editableErrors}
            handleInputChange={handleInputChange}
            handleSaveClick={handleSaveClick}
            handleSocialMediaDeleteClick={handleSocialMediaDeleteClick}
          />
        ))}
      </CardBody>
    </>
  );
};

export default Editsocialmedia;